<script>
  import { fly, slide } from 'svelte/transition';
  import viewport from '@/js/utils/useViewportAction.js';

  export let about;
  let grow = false;
</script>

<section class="about-wrap">
  <div class="container">
    <div class="about flexbox">
      <div class="col col-50 col-m-full">
        <h2
          class="about__title h2"
          class:grow
          use:viewport
          on:enterViewport={() => (grow = true)}
        >
          {@html about.title}
        </h2>
      </div>
      <div class="col col-50 col-m-full">
        <div
          class="about__right"
          class:grow
          use:viewport
          on:enterViewport={() => (grow = true)}
        >
          <p>
            {@html about.desc}
          </p>
          <img
            class="about__image"
            width="50"
            height="60"
            src={about.icon.src}
            alt={about.icon.alt}
          />
        </div>
      </div>
    </div>
  </div>
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .about-wrap {
    overflow: hidden;
  }

  .about {
    @include resp-max('m') {
      padding: 6rem 0;
      border-bottom: 1px solid $light-border;
    }
    &.flexbox {
      @include resp-min('m') {
        padding: 8rem 0 10rem;
      }

      margin: 0 -5rem;

      .col {
        padding: 0 5rem;
      }
    }

    &__title {
      &.grow {
        animation: fade-up 1s ease-in-out backwards;
      }

      @include resp-max('m') {
        max-width: 26rem;
        text-align: center;
        margin: 0 auto;
        font-size: 5rem;
      }

      :global span {
        display: block;
        color: var(--aqua-1);
      }
    }

    &__right {
      &.grow {
        animation: fade-up 1s cubic-bezier(0.22, 1, 0.36, 1) backwards;
      }

      @include resp-max('m') {
        margin: 3rem 0 0;
      }
    }

    &__image {
      @include resp-max('m') {
        margin: {
          top: 3.5rem;
          left: auto;
          right: auto;
        }
      }
      margin: 2rem 0 0;
    }
  }
</style>
